export default __webpack_public_path__ + "static/media/print.4827ba8e.png";